<div class="btn-group btn-map" ng-show="$root.permissions.painelUsuario.canRead">
  <button class="btn" ng-class="{'active': (active == 'users')}" title="Usuários" ng-click="activate('users')">
    <i class="fa fa-user" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map" ng-show="$root.permissions.usosMaquinas.canRead">
  <button class="btn" ng-class="{'active': (active == 'usosMaquinas')}" title="Usos de Máquinas" ng-click="activate('usosMaquinas')">
    <i class="icon-fulltrator" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map" ng-show="$root.permissions.tarefa.canRead">
  <button class="btn" ng-class="{'active': ['tasks', 'addTask'].indexOf(active) > -1}" title="Tarefas" ng-click="activate('tasks')">
    <i class="icon-newtask"></i>
  </button>
</div>
<div class="btn-group btn-map" ng-show="canReadRecommendations()">
  <button class="btn"
          ng-class="{'active': ['addRecommendation', 'recommendations', 'addRecommendationCorrecao', 'addRecommendationAdubacao'].indexOf(active) > -1}"
          ng-click="activate('recommendations')"
          title="Recomendações">
    <i class="icon-recomendacoes" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map" ng-show="canReadApplications()">
  <button class="btn" ng-class="{'active': ['applications', 'editApplication'].includes(active)}" ng-click="activate('applications')" title="Aplicações">
    <i class="icon-pulverization-fill" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map" ng-show="$root.permissions.demarcacaoArea.canRead">
  <button class="btn"
          ng-class="{'active': ['historyDrawPolygons', 'drawPolygon'].indexOf(active) > -1}"
          ng-click="activate('historyDrawPolygons')"
          title="Áreas Demarcadas">
    <i class="icon-layer"></i>
  </button>
</div>
<div class="btn-group btn-map">
  <button class="btn"
          ng-class="{'active': ['historyMapListing', 'painelCriarMapa'].includes(active)}"
          ng-click="activate('historyMapListing')"
          ng-if="$root.permissions.ocorrencia.canRead || $root.permissions.mapas.canManage"
          title="Mapas">
    <i class="fa fa-map"></i>
  </button>
</div>
<propriedade-tracking-button gleba="gleba"></propriedade-tracking-button>
<div class="btn-group btn-map"
     ng-if="$root.permissions.ocorrencia.canRead && isActivityActive()">
  <button class="btn"
          ng-class="{'active': (active === 'occurrencesSummary')}"
          ng-click="activate('occurrencesSummary')"
          title="Resumo de ocorrências">
    <i class="icon-ocurrences" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map"
     ng-if="$root.permissions.colheita_afericao.canRead">
  <button class="btn"
          ng-class="{'active': (active === 'historicoAfericoes')}"
          ng-click="activate('historicoAfericoes')"
          title="Aferições">
    <i class="fa fa-calculator" aria-hidden="true"></i>
  </button>
</div>
<div class="btn-group btn-map"
      ng-if="$root.permissions.recomendacao.canRead">
  <button class="btn" onclick="window.location.href='#!/cronograma-fungicidas';" title="Cronograma de Fungicidas">
    <i class="icon-showerdar"></i>
  </button>
</div>
<propriedade-button-weather active="active === 'weatherForecast'"
                            ng-click="weatherForecast !== 'loading' && activate('weatherForecast')"
                            data="weatherForecast"
                            ng-if="showWeatherButton"></propriedade-button-weather>
